var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebinar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 15.375H25.625V14.25C25.625 13.9516 25.5065 13.6655 25.2955 13.4545C25.0845 13.2435 24.7984 13.125 24.5 13.125C24.2016 13.125 23.9155 13.2435 23.7045 13.4545C23.4935 13.6655 23.375 13.9516 23.375 14.25V15.375H16.25C15.7535 15.3775 15.278 15.5758 14.9269 15.9269C14.5758 16.278 14.3775 16.7535 14.375 17.25V28.5C14.3775 28.9965 14.5758 29.472 14.9269 29.8231C15.278 30.1742 15.7535 30.3725 16.25 30.375H19.1562L17.6187 32.2969C17.4341 32.5313 17.3492 32.8291 17.3825 33.1256C17.4159 33.4222 17.5647 33.6937 17.7969 33.8812C17.9982 34.0373 18.2452 34.123 18.5 34.125C18.6692 34.1255 18.8362 34.0878 18.9888 34.0147C19.1414 33.9417 19.2755 33.8352 19.3813 33.7031L22.0438 30.375H26.9562L29.6188 33.7031C29.7245 33.8352 29.8586 33.9417 30.0112 34.0147C30.1638 34.0878 30.3308 34.1255 30.5 34.125C30.7548 34.123 31.0018 34.0373 31.2031 33.8812C31.4353 33.6937 31.5841 33.4222 31.6175 33.1256C31.6508 32.8291 31.5659 32.5313 31.3812 32.2969L29.8438 30.375H32.75C33.2465 30.3725 33.722 30.1742 34.0731 29.8231C34.4242 29.472 34.6225 28.9965 34.625 28.5V17.25C34.6225 16.7535 34.4242 16.278 34.0731 15.9269C33.722 15.5758 33.2465 15.3775 32.75 15.375ZM32.375 28.125H16.625V17.625H32.375V28.125Z",
    fill: "#79747E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinar);
export default __webpack_public_path__ + "static/media/Webinar.184b90f44929dd23a55facdd24a1222c.svg";
export { ForwardRef as ReactComponent };